import { defer } from 'react-router-dom'
import { getQueryStringParamsFromStringUrl, logger } from '$utils'
import { isAppStateReady } from 'src/state/store'
import useWorkforceStore from '../../store'
import { leaveRequestService } from '$services'
import { AccessType, LoadedLeaveRequestStatus } from '$constants'
import { ILeaveRequest, ILeaveType, StaffMember } from '$models'

export default async function loader({ request: { url } }) {
  const queryParams = getQueryStringParamsFromStringUrl(url)

  logger.debug(
    '[loader] About to await AppState being ready in employee Leave Status loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in employee Leave Status loader'
  )

  const { staffMemberId, requestId, status, t: token } = queryParams
  if (token) {
    //ls.authorizationData is the key where angular also sets the token
    //Here we are reusing the same key in the local storage to store the
    //token when the standalone page is accessed
    window.localStorage.setItem(
      'ls.authorizationData',
      JSON.stringify({ accessToken: token, accessType: AccessType.Standalone })
    )
  }

  const getStaffMember = staffMemberId
    ? useWorkforceStore.getState().getStaffMemberPersonalDetails(staffMemberId)
    : null

  const updatedLeaveRequest = leaveRequestService.updateStatus(
    requestId,
    status as unknown as LoadedLeaveRequestStatus
  )

  // TODO: Refactor this when we polish up the leave request feature - Leave Types pages
  // needs to be migrated to start using the new core-api-sdk library
  const leaveType = updatedLeaveRequest.then((leaveRequest) =>
    leaveRequestService.getLeaveType(leaveRequest.leaveTypeId)
  )

  return defer({
    data: Promise.all([updatedLeaveRequest, leaveType, getStaffMember])
      .then((result) => {
        return result as [ILeaveRequest, ILeaveType, StaffMember | null]
      })
      .catch((error) => {
        logger.error('Employee Leave Status Promise.all error', error)
        return false
      }),
  })
}
